/**
 * Public surface of the `enrollment` feature.
 *
 * The per-sequence Enrollments tab inside `features/sequences` consumes
 * this module rather than reaching into `./components/...` or
 * `./lib/...` directly.
 */

export { Enrollment } from "./components";

// Drawer control surface — openers (Configure modal, sequence page, …) use
// `openDrawer({ jobId, sequenceId, previewSessionId })` to present the
// review-and-enroll drawer, paired with a mounted `<Enrollment.PreviewDrawer />`.
export { usePreviewStore } from "./store/preview-store";
export type { PreviewDrawerContext } from "./store/preview-store";

export type { EnrollmentListItem, EnrollmentKpi } from "./lib/types";
export type { EnrollmentStatus, EnrollmentOutcome } from "./lib/types";
